import { MenuLinks } from '@/constants/menu'

export type AdminBreadcrumbItem = { label: string; link?: string }

/** Breadcrumb trail for pages under the dashboard shell sidebar (Super Admin). */
export function dashboardShellBreadcrumb(currentLabel: string): AdminBreadcrumbItem[] {
	return [
		{ label: 'Dashboard', link: MenuLinks.Dashboard },
		{ label: currentLabel },
	]
}

/** Breadcrumb trail for pages under Settings → Administrators. */
export function administratorsBreadcrumb(currentLabel: string): AdminBreadcrumbItem[] {
	return [
		{ label: 'Administrators', link: MenuLinks.ViewAdministratorSubMenu },
		{ label: currentLabel },
	]
}
